import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { EvaluationMeasureAction, EvaluationMeasureDetail } from "@intocare/data-access/portal/care";
import { TagComponent, TagVariant } from "@intocare/design/design-system-base";

const STATUS_DISPLAY: Record<EvaluationMeasureAction, { label: string; variant: TagVariant }> = {
	ACTIVE: { label: "domain-codes.evaluationMeasureStatus.ACTIVE.display", variant: "success" },
	NEW: { label: "domain-codes.evaluationMeasureStatus.NEW.display", variant: "info" },
	STOPPED: { label: "domain-codes.evaluationMeasureStatus.STOPPED.display", variant: "danger" },
};

export type EvaluationMeasureStatusTagData = Pick<EvaluationMeasureDetail, "action">;

@Component({
	selector: "ic-evaluation-measure-status-tag",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TagComponent, TranslateModule],
	templateUrl: "./evaluation-measure-status-tag.component.html",
	host: { class: "inline-block" },
})
export class EvaluationMeasureStatusTagComponent<
	T extends EvaluationMeasureStatusTagData = EvaluationMeasureStatusTagData,
> {
	readonly dataEvaluationMeasure = input.required<T>();

	protected readonly data = computed<{ label: string; variant: TagVariant }>(
		() => STATUS_DISPLAY[this.dataEvaluationMeasure().action],
	);
}
